<template>
  <div class="tabs">
    <div
      class="tab-item font darkgray-font"
      v-for="(item, index) in data"
      :class="{'primary-font': activeValue == item.value}"
      :key="item.value"
      @click="change(item, index)"
    >{{item.label}}</div>
  </div>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'

export default {
  props: {
    data: Array,
    activeValue: Number,
  },
  setup(props, { emit }) {
    console.log(2223, props)
    const change = (item, index) => {
      emit('change', item, index)
    }
    return { change }
  },
}
</script>

<style lang="scss">
.tabs {
  display: flex;
  align-items: center;
  overflow-y: hidden;
  flex-wrap: nowrap;
  height: 84px;
  background-color: #f4f6f9;
  .tab-item {
    list-style: none;
    white-space: nowrap;
    transition: all 0.3s;
    padding: 22px 27px;
  }
}
</style>